import { Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "@/lib/auth";
import { logAccessDenied } from "@/lib/access-log";

export const RequireSuperAdmin = ({ children }: { children: JSX.Element }) => {
  const { user, loading, isSuperAdmin } = useAuth();
  const location = useLocation();
  const denied = !loading && (!user || !isSuperAdmin);

  useEffect(() => {
    if (denied) {
      logAccessDenied({
        route: location.pathname + location.search,
        reason: !user ? "unauthenticated" : "missing_role:super_admin",
        resource: "route:super_admin",
        errorCode: "403",
      });
    }
  }, [denied, user, location.pathname, location.search]);

  if (loading) return <div className="min-h-screen grid place-items-center text-muted-foreground">…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  if (!isSuperAdmin) return <Navigate to="/" replace />;
  return children;
};
